import * as actionType from "./ActionTypes";
import { findIndex, sumBy } from "lodash";

export default function fiveMBookingReducer(state = {}, action) {
  const { payload } = action;
  switch (action.type) {
    case actionType.FIVE_M_BOOKING_LOADED:
      return (state = payload);

    case actionType.FIVE_M_BOOKING_DONE:
      var bookedShipment = {
        ...state[payload.Market],
      };
      const findId = findIndex(bookedShipment.subRows, (data) => {
        return (
          data.DailyContainerPlanning5MId === payload.DailyContainerPlanning5MId
        );
      });
      bookedShipment.subRows[findId] = {
        ...bookedShipment.subRows[findId],
        Market: payload["Market"],
        Booking_Number: payload["BookingNo"],
        AssignContainer5MId: payload["AssignContainer5MId"],
      };
      return {
        ...state,
        [`${payload.Market}`]: bookedShipment,
      };

    case actionType.FIVE_M_BOOKING_UPDATED:
      var approvedShipmentBooking = {
        ...state[payload.Market],
      };
      for (const item of approvedShipmentBooking.subRows) {
        if (item["AssignContainer5MId"] === payload["AssignContainer5MId"]) {
          const indexOfItem = approvedShipmentBooking.subRows.indexOf(item);
          approvedShipmentBooking.subRows[indexOfItem] = {
            ...item,
            Booking_Number: payload["BookingNo"],
          };
          break;
        }
      }
      return {
        ...state,
        [`${payload.Market}`]: approvedShipmentBooking,
      };

    case actionType.FIVE_M_BOOKING_SENT_FOR_APPROVAL: 
      var shipmentForApproval = {
        ...state[payload.Market],
      };
      const findApprovedId = findIndex(shipmentForApproval.subRows, (data) => {
        return (
          data.DailyContainerPlanning5MId === payload.DailyContainerPlanning5MId
        );
      });
      if (payload.Reason === "" && payload.manualReason !== "") {
        shipmentForApproval.subRows[findApprovedId] = {
        ...shipmentForApproval.subRows[findApprovedId],
        AssignContainer5MId: payload.AssignContainer5MId,
        Reason: `${payload.manualReason}`,
        STATUS: "Pending",
      };
    }
    else if (payload.Reason !== "" && payload.manualReason !== "") {
      shipmentForApproval.subRows[findApprovedId] = {
        ...shipmentForApproval.subRows[findApprovedId],
        AssignContainer5MId: payload.AssignContainer5MId,
        Reason: `${payload.Reason},${payload.manualReason}`,
        STATUS: "Pending",
      };
    } else{
      shipmentForApproval.subRows[findApprovedId] = {
        ...shipmentForApproval.subRows[findApprovedId],
        AssignContainer5MId: payload.AssignContainer5MId,
        Reason: payload.Reason,
        STATUS: "Pending",
      };
    }
      return {
        ...state,
        [`${payload.Market}`]: shipmentForApproval,
      };

    case actionType.FIVE_M_BOOKING_STATUS_UPDATE_FROM_JD:
      var jdResponseOnShipment = {
        ...state[payload.Market],
      };
      const findStatusIdFromJD = findIndex(
        jdResponseOnShipment.subRows,
        (data) => {
          return (
            data.DailyContainerPlanning5MId ===
            payload.DailyContainerPlanning5MId
          );
        }
      );
      jdResponseOnShipment.subRows[findStatusIdFromJD] = {
        ...jdResponseOnShipment.subRows[findStatusIdFromJD],
        STATUS: payload.DeereStatus,
      };
      return {
        ...state,
        [`${payload.Market}`]: jdResponseOnShipment,
      };

    case actionType.FIVE_M_PLANNING_DONE:
      var plannedShipment = {
        ...state[payload.Market],
      };
      for (const item of plannedShipment.subRows) {
        if (
          item.Booking_Number === payload.Booking_Number &&
          item.AssignContainerId === payload.AssignContainerId
        ) {
          const indexOfItem = plannedShipment.subRows.indexOf(item);
          plannedShipment.subRows[indexOfItem] = {
            ...item,
            Container_Number: payload.Container_Number,
          };
          break;
        }
      }
      return {
        ...state,
        [`${payload.Market}`]: plannedShipment,
      };

    case actionType.FIVE_M_COLUMN_UPDATED:
      var updatedDataShipment = {
        ...state[payload.Market],
      };
      const findInsertedDataId = findIndex(
        updatedDataShipment.subRows,
        (data) => {
          return (
            data.DailyContainerPlanning5MId ===
            payload.DailyContainerPlanning5MId
          );
        }
      );
      if(findInsertedDataId >= 0){ 
        updatedDataShipment.subRows[findInsertedDataId] = {
        ...updatedDataShipment.subRows[findInsertedDataId],
        [payload.ColumnName]: payload.Value,
      };}
      return {
        ...state,
        [`${payload.Market}`]: updatedDataShipment,
      };

    case actionType.FIVE_M_COLUMN_UPDATED_FOR_INSPECTION:
      var updatedShipmentForInspection = {
        ...state[payload.Market],
        [`${payload.ColumnName}`]: payload.Value,
      };
      var updatedSubRowsForInspection = [];
      for (let i = 0; i < updatedShipmentForInspection.subRows.length; i++) {
        updatedSubRowsForInspection.push({
          ...updatedShipmentForInspection.subRows[i],
          [`${payload.ColumnName}`]: `${payload.Value}`,
        });
      }
      return {
        ...state,
        [`${payload.Market}`]: {
          ...updatedShipmentForInspection,
          subRows: updatedSubRowsForInspection,
        },
      };

    case actionType.FIVE_M_INSERT_DROPDOWN_DATA:
      var updatedPODShipment = {
        ...state[payload.Market],
      };
      const findInsertedPODId = findIndex(
        updatedPODShipment.subRows,
        (data) => {
          return (
            data.DailyContainerPlanning5MId ===
            payload.DailyContainerPlanning5MId
          );
        }
      );
      updatedPODShipment.subRows[findInsertedPODId] = {
        ...updatedPODShipment.subRows[findInsertedPODId],
        [payload.ColumnName]: payload.Value,
      };
      return {
        ...state,
        [`${payload.Market}`]: updatedPODShipment,
      };

    case actionType.FIVE_M_DELETE_SUBROW:
      // if(payload.deleteIdPayload.length === 0){
        payload.statePayload(payload.deleteIdPayload)
      // }
      return (state = payload.deleteIdPayload);

      case actionType.FIVE_M_UPDATE_BOOKING_NO:
        var updateBookingNo = {
          ...state[payload.Market]
        }
        const findUpdatedBookingNoId = findIndex(
          updateBookingNo.subRows,
          (data) => {
            return (
              data.DailyContainerPlanning5MId === payload.DailyContainerPlanning5MId
            );
          }
        );
        if(payload.bookingNo !== ""){
          updateBookingNo.subRows[findUpdatedBookingNoId] = {
            ...updateBookingNo.subRows[findUpdatedBookingNoId],
            Booking_Number: payload.bookingNo,
          };
        }else{
          updateBookingNo.subRows[findUpdatedBookingNoId] = {
            ...updateBookingNo.subRows[findUpdatedBookingNoId],
            Booking_Number: payload.bookingNo,
          };
        }
        return {
          ...state,
          [`${payload.Market}`]: updateBookingNo,
        };

      case actionType.FIVE_M_UPDATE_BOOKING_QTY:
        var updateQty = {
          ...state[payload.Market]
        }
        var arr = []
        const findUpdatedQtyId = findIndex(
          updateQty.subRows,
          (data) => {
            return (
              data.DailyContainerPlanning5MId === payload.DailyContainerPlanning5MId
            );
          }
        );
        updateQty.subRows[findUpdatedQtyId] = {
          ...updateQty.subRows[findUpdatedQtyId],
          Quantity : payload.Quantity
        }
        for (let i = 0; i < updateQty.subRows.length; i++) {
          arr.push(updateQty.subRows[i].Quantity)
        }
        let QtySummation = (sumBy(arr, function(o){return parseInt(o)}));
        updateQty.Quantity = QtySummation
        return {
          ...state,
          [payload.Market] : updateQty
        }
  
      case actionType.FIVE_M_UPDATE_BOOKING_CONTAINER_QTY:
        var updateContainerQty = {
          ...state[payload.Market]
        }
        var arrs = []
        const findUpdatedContainerQtyId = findIndex(
          updateContainerQty.subRows,
          (data) => {
            return (
              data.DailyContainerPlanning5MId === payload.DailyContainerPlanning5MId
            );
          }
        );
        updateContainerQty.subRows[findUpdatedContainerQtyId] = {
          ...updateContainerQty.subRows[findUpdatedContainerQtyId],
          Container_Count : payload.Container_Count
        }
        for (let i = 0; i < updateContainerQty.subRows.length; i++) {
          arrs.push(updateContainerQty.subRows[i].Container_Count)
        }
        let ContainerQtySummation = (sumBy(arrs, function(o){return parseInt(o)}));
        updateContainerQty.Container_Count = ContainerQtySummation
        return {
          ...state,
          [payload.Market] : updateContainerQty
        }
    default:
      return state;
  }
}
